import { FlagSyncLogoWithTitle } from '@/components/svgs/logo';

import { FooterBrandIcons } from './footer.brand-icons';
import { FooterLegalLinks } from './footer.legal-links';
import { FooterNavLinks } from './footer.nav-links';
import { FooterTagline } from './footer.tagline';

export const Footer = () => {
  return (
    <>
      <footer className="hidden md:grid grid-cols-[auto_1fr] relative z-20 gap-y-20">
        <div className="flex flex-col gap-2.5 w-fit">
          <FooterNavLinks />
        </div>
        <div className="justify-self-end">
          <FooterTagline />
        </div>
        <div className="flex flex-col justify-self-start gap-2">
          <FlagSyncLogoWithTitle className="h-10" />
          <FooterLegalLinks />
        </div>
        <div className="justify-self-end place-self-center self-end flex flex-col gap-4">
          <FooterBrandIcons />
          <p className="text-xs leading-5 text-right text-muted-foreground">
            ©2025 FlagSync Inc.
          </p>
        </div>
      </footer>
      <footer className="grid md:hidden grid-cols-1 relative z-20 gap-y-12">
        <FooterTagline className="justify-between" />
        <div className="flex flex-col gap-2.5 w-fit">
          <FooterNavLinks />
        </div>

        <div className="flex flex-col gap-2">
          <div className="flex justify-between items-center">
            <div className="flex flex-col items-start gap-2">
              <FlagSyncLogoWithTitle className="h-8" />
            </div>
            <FooterBrandIcons />
          </div>
          <div className="flex flex-col gap-px">
            <FooterLegalLinks />
            <p className="text-xs leading-5">©2025 FlagSync Inc.</p>
          </div>
        </div>
      </footer>
    </>
  );
};
